export default "__VITE_ASSET__6SAqyrES__"